@let item = solicitacao();

<section class="detalhe-cartao" aria-labelledby="detalhe-resumo-titulo">
  <h3 class="detalhe-cartao-titulo" id="detalhe-resumo-titulo">Resumo da Manifestação</h3>

  <dl class="detalhe-dados">
    <div class="detalhe-dado">
      <dt>Protocolo</dt>
      <dd class="detalhe-dado-forte">{{ item.protocolo }}</dd>
    </div>
    <div class="detalhe-dado">
      <dt>Data de envio</dt>
      <dd>{{ dataEnvio() }}</dd>
    </div>
    <div class="detalhe-dado">
      <dt>Classificação</dt>
      <dd>
        <span class="detalhe-categoria" [attr.data-categoria]="item.categoria">
          <i-lucide [name]="iconeCategoria()" size="12" aria-hidden="true"></i-lucide>
          {{ rotuloCategoria() }}
        </span>
      </dd>
    </div>
    <div class="detalhe-dado">
      <dt>Tipo</dt>
      <dd>
        {{ item.tipo }}
        @if (item.segundaVia) {
          <span class="detalhe-via">Segunda via</span>
        }
      </dd>
    </div>
    <div class="detalhe-dado">
      <dt>Status</dt>
      <dd>
        <span class="detalhe-status" [attr.data-status]="item.status">{{ rotuloStatus() }}</span>
      </dd>
    </div>
    @if (item.prazo) {
      <div class="detalhe-dado detalhe-dado-largo">
        <dt>Prazo</dt>
        <dd>{{ item.prazo }}</dd>
      </div>
    }
  </dl>

  <!-- Sempre presente para o leitor de tela anunciar o aviso; vazio, não ocupa espaço. -->
  <div role="status" aria-live="polite">
    @if (avisoComplemento()) {
      <p class="detalhe-complemento-aviso" data-html2canvas-ignore>
        <i-lucide name="circle-check" size="18" aria-hidden="true"></i-lucide>
        {{ avisoComplemento() }}
      </p>
    }
  </div>

  @if (item.pendencia; as pendencia) {
    <app-complemento-solicitacao
      [protocolo]="item.protocolo"
      [pendencia]="pendencia"
      (enviado)="aoEnviarComplemento($event, pendencia.pausaPrazo)"
    ></app-complemento-solicitacao>
  }

  @if (item.sic; as sic) {
    @if (sic.complemento; as complemento) {
      <app-complemento-pedido-sic
        [protocolo]="item.protocolo"
        [complemento]="complemento"
        (enviado)="aoEnviarComplementoSic($event)"
      ></app-complemento-pedido-sic>
    }

    <!-- Contestar é da área logada: aqui só o convite, sem botão. -->
    @if (sic.sujeitoARecurso) {
      <p class="detalhe-recurso">
        <i-lucide name="scale" size="16" aria-hidden="true"></i-lucide>
        <span>
          Sujeito a recurso até {{ sic.dataLimiteRecurso }}. Para contestar,
          <a class="detalhe-recurso-link" routerLink="/login">entre na área do cidadão</a>.
        </span>
      </p>
    }

    <h4 class="detalhe-secao-titulo">Assunto</h4>
    <p class="detalhe-texto">{{ sic.assunto }}</p>

    <h4 class="detalhe-secao-titulo">Descrição</h4>
    <p class="detalhe-texto">{{ item.descricao }}</p>

    @if (sic.departamento) {
      <h4 class="detalhe-secao-titulo">Categoria temática</h4>
      <p class="detalhe-texto">{{ sic.departamento }}</p>
    }

    <h4 class="detalhe-secao-titulo">Arquivos anexados</h4>
    @if (item.arquivos.length) {
      <ul class="detalhe-arquivos">
        @for (arquivo of item.arquivos; track arquivo.id) {
          <li class="detalhe-resposta-anexo">
            <i-lucide class="detalhe-resposta-anexo-icone" name="file" size="18" aria-hidden="true"></i-lucide>
            <span class="detalhe-resposta-anexo-texto">
              <strong>{{ arquivo.nome }}</strong>
              <span>{{ arquivo.tamanho }}</span>
            </span>
          </li>
        }
      </ul>
    } @else {
      <p class="detalhe-texto">Nenhum arquivo anexado</p>
    }
  } @else if (item.descricao) {
    <!-- O agendamento feito pela área do cidadão não tem descrição nem endereço: sem o texto, o
         bloco não aparece — nem o título, nem o ícone sozinho. -->
    <h4 class="detalhe-secao-titulo">Assunto / Descrição</h4>
    <p class="detalhe-texto">{{ item.descricao }}</p>
  }

  @if (item.endereco) {
    <p class="detalhe-endereco">
      <i-lucide name="map-pin" size="16" aria-hidden="true"></i-lucide>
      {{ item.endereco }}
    </p>
  }

  <!--
    Solicitação de serviço: um bloco por resposta do órgão, da mais recente para a mais antiga.
    Fica dentro do componente de propósito — o PDF de /acompanhamento clona este elemento.
    Sem respostas (Ouvidoria e SIC), segue o parecer único de sempre.
  -->
  @if (respostas().length) {
    @for (resposta of respostas(); track resposta.idTitulo) {
      <article class="detalhe-parecer detalhe-resposta" [attr.aria-labelledby]="resposta.idTitulo">
        <header class="detalhe-resposta-cabecalho">
          <h4 class="detalhe-parecer-titulo" [id]="resposta.idTitulo">
            <i-lucide name="message-square" size="20" aria-hidden="true"></i-lucide>
            {{ tituloResposta() }}
          </h4>

          <p class="detalhe-resposta-meta">
            @if (resposta.status) {
              <span class="visually-hidden">Status:</span>
              <span class="detalhe-status" [attr.data-status]="resposta.tomStatus">{{ resposta.status }}</span>
            }
            <span class="visually-hidden">Respondida em</span>
            <span>{{ resposta.respondidaEm }}</span>
          </p>
        </header>

        @if (resposta.tipo) {
          <p class="detalhe-resposta-tipo">
            <strong>Tipo de resposta:</strong> {{ resposta.tipo }}
            @if (resposta.fundamento) {
              <br><strong>Fundamento legal:</strong> {{ resposta.fundamento }}
            }
          </p>
        }

        @for (paragrafo of resposta.paragrafos; track $index) {
          <p class="detalhe-parecer-texto detalhe-resposta-texto">{{ paragrafo }}</p>
        }

        @if (resposta.formularios.length) {
          <h5 class="detalhe-resposta-subtitulo">Formulários indicados</h5>
          <ul class="detalhe-resposta-lista">
            @for (formulario of resposta.formularios; track $index) {
              <li>{{ formulario }}</li>
            }
          </ul>
        }

        @if (resposta.links.length) {
          <h5 class="detalhe-resposta-subtitulo">Links</h5>
          <ul class="detalhe-resposta-lista">
            @for (link of resposta.links; track $index) {
              <li>
                <a class="detalhe-resposta-link" [href]="link" target="_blank" rel="noopener noreferrer">
                  {{ link }}
                  <i-lucide name="external-link" size="14" aria-hidden="true"></i-lucide>
                  <span class="visually-hidden">(abre em nova aba)</span>
                </a>
              </li>
            }
          </ul>
        }

        @if (resposta.anexos.length) {
          <h5 class="detalhe-resposta-subtitulo">Anexos</h5>
          <ul class="detalhe-resposta-anexos">
            @for (anexo of resposta.anexos; track anexo.codigo) {
              <li class="detalhe-resposta-anexo">
                <i-lucide class="detalhe-resposta-anexo-icone" name="file" size="18" aria-hidden="true"></i-lucide>

                <span class="detalhe-resposta-anexo-texto">
                  <strong>{{ anexo.nome }}</strong>
                  <span>{{ anexo.tamanho }}</span>
                </span>

                <!-- O botão e o aviso ficam fora do PDF: no papel, só o nome do arquivo faz sentido. -->
                <button type="button" class="detalhe-resposta-baixar" data-html2canvas-ignore
                  [disabled]="baixando() !== null" [attr.aria-busy]="baixando() === anexo.codigo"
                  [attr.aria-label]="(baixando() === anexo.codigo ? 'Baixando ' : 'Baixar ') + anexo.nome"
                  (click)="baixarAnexo(anexo)">
                  <i-lucide name="download" size="14" aria-hidden="true"></i-lucide>
                  {{ baixando() === anexo.codigo ? 'Baixando...' : 'Baixar' }}
                </button>

                @if (erroAnexo()?.codigo === anexo.codigo) {
                  <p class="detalhe-resposta-erro" role="alert" data-html2canvas-ignore>
                    {{ erroAnexo()?.mensagem }}
                  </p>
                }
              </li>
            }
          </ul>
        }
      </article>
    }
  } @else if (item.resposta; as resposta) {
    <div class="detalhe-parecer">
      <h4 class="detalhe-parecer-titulo">
        <i-lucide name="circle-check" size="20" aria-hidden="true"></i-lucide>
        Parecer de Conclusão Oficial
      </h4>

      @for (paragrafo of resposta.paragrafos; track $index) {
        <p class="detalhe-parecer-texto">{{ paragrafo }}</p>
      }
    </div>
  }
</section>

<section class="detalhe-cartao" aria-labelledby="detalhe-linha-titulo">
  <h3 class="detalhe-cartao-titulo" id="detalhe-linha-titulo">Linha do Tempo</h3>

  <ol class="detalhe-linha">
    @for (evento of linhaDoTempo(); track evento.id) {
      <li class="detalhe-linha-item" [attr.data-tom]="evento.tom">
        <span class="detalhe-linha-marca" aria-hidden="true"></span>

        <span class="detalhe-linha-rotulo">{{ evento.rotulo }}</span>
        <span class="detalhe-linha-quando">{{ evento.quando }}</span>
        <p class="detalhe-linha-descricao">{{ evento.descricao }}</p>

        @if (evento.anexos?.length) {
          <ul class="detalhe-linha-anexos" aria-label="Arquivos enviados">
            @for (anexo of evento.anexos; track $index) {
              <li>
                <i-lucide name="paperclip" size="14" aria-hidden="true"></i-lucide>
                {{ anexo.nome }} ({{ anexo.tamanho }})
              </li>
            }
          </ul>
        }
      </li>
    }
  </ol>
</section>
